/* eslint-disable jsx-a11y/anchor-is-valid */
import axios from "axios";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

const CardThreeEmployee = () => {
  const [currentPage, setCurrentPage] = useState(1);
  const jobsPerPage = 8;
  const [card, setCard] = useState([]);
  const allJobsCombined = [...card];
  const indexOfLastJob = currentPage * jobsPerPage;
  const indexOfFirstJob = indexOfLastJob - jobsPerPage;
  const currentJobs = allJobsCombined?.slice(indexOfFirstJob, indexOfLastJob);

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  const AllCardData = async () => {
    try {
      const response = await axios.get("https://dummyjson.com/products");
      setCard(response?.data?.products);
      console.log(response?.data);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    AllCardData();
  }, []);
  return (
    <>
      <div className="row">
        {currentJobs?.map((job) => (
          <div className="col-sm-6 col-lg-4 col-xl-3">
            <Link to={'/jobviewsingle'}>
            <div className="job-list-style1 bdr1" style={{height:'auto'}}>
              <div className="icon d-flex align-items-center mb20">
                <img
                  alt="img"
                  loading="lazy"
                  width={60}
                  height={60}
                  decoding="async"
                  data-nimg={1}
                  className="wa"
                  style={{ color: "transparent" }}
                  srcSet="https://freeio-app-nextjs.vercel.app/_next/image?url=%2Fimages%2Fteam%2Fclient-2.png&w=64&q=75
                "
                  src="https://freeio-app-nextjs.vercel.app/_next/image?url=%2Fimages%2Fteam%2Fclient-2.png&w=64&q=75"
                />
                <h6 className="mb-0 text-thm ml20">
                  {job?.brand + " " + job?.category}
                </h6>
                <span className="fav-icon flaticon-star" />
              </div>
              <div className="details">
                <h5 className="mb20">
                  <Link to={'/jobviewsingle'}>{job?.description}</Link>
                </h5>
                <p className="list-inline-item c">$125k-$135k Hourly</p>
                <p className="list-inline-item c bdrl1 pl10">
                  1-5 {job?.rating}
                </p>
                <p className="list-inline-item c bdrl1 pl10">Expensive</p>
                <p className="list-inline-item c bdrl1 pl10">
                  Price{job?.price}
                </p>
              </div>
            </div>
            </Link>
          </div>
        ))}
      </div>
      <div className="mt30">
        <div className="mbp_pagination text-center">
          <ul className="page_navigation">
            <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
              <a
                className="page-link"
                onClick={() => paginate(currentPage - 1)}
              >
                <span className="fas fa-angle-left" />
              </a>
            </li>
            {[...Array(Math.ceil(allJobsCombined?.length / jobsPerPage)).keys()]
              .slice(currentPage - 1, currentPage + 2)
              .map((number) => (
                <li
                  key={number}
                  className={`page-item ${
                    currentPage === number + 1 ? "active" : ""
                  }`}
                >
                  <a className="page-link" onClick={() => paginate(number + 1)}>
                    {number + 1}
                  </a>
                </li>
              ))}
            <li
              className={`page-item ${
                currentPage === Math.ceil(allJobsCombined?.length / jobsPerPage)
                  ? "disabled"
                  : ""
              }`}
            >
              <a
                className="page-link"
                onClick={() => paginate(currentPage + 1)}
              >
                <span className="fas fa-angle-right" />
              </a>
            </li>
          </ul>
        </div>
      </div>
    </>
  );
};

export default CardThreeEmployee;
